import React from 'react';
import {inject} from 'mobx-react';
import {observe} from 'mobx';
import Snackbar from 'material-ui/Snackbar';

@inject('alertStore')
export default class AlertContainerWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      message: ''
    };
  }

  componentWillMount(){
    this.listener = observe(this.props.alertStore, () => {
      this.handleTouchTap(this.props.alertStore.event.text);
    });
  }

  handleTouchTap = (text) => {
    this.setState({
      open: true,
      message: text
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
      message: ''
    });
  };

  render(){
    return (
      <Snackbar
        open={this.state.open}
        message={this.state.message}
        autoHideDuration={4000}
        onRequestClose={this.handleRequestClose}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/blocks/AlertContainerWrapper.jsx